import { CustomElementProps } from '@rcg/cruise-search-components';
import Offers from 'components/TargetedOffers/Offers';
import { OffersWrapper } from './styles';

const FilterOffers = (props: CustomElementProps) => {
	return (
		<OffersWrapper>
			<Offers {...props} />
		</OffersWrapper>
	);
};

export default FilterOffers;
